import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipients-chips.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipients-chips.component.scss?ngResource";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, EventEmitter, Input, Output } from "@angular/core";
let RecipientsChipsComponent = class RecipientsChipsComponent {
    recipients = [];
    errorMessage;
    inputTouched = false;
    validEmail = true;
    listOfRecipients = new EventEmitter();
    addOnBlur = true;
    separatorKeysCodes = [ENTER, COMMA];
    add(event) {
        this.inputTouched = true;
        const value = (event.value || '').trim();
        var regExPattern = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$");
        var result = regExPattern.test(value);
        if (!result) {
            this.validEmail = false;
        }
        else {
            this.validEmail = true;
            // Add our recipient
            if (value) {
                const recipient = {
                    id: 0,
                    reportScheduleId: 0,
                    recipientEmail: value
                };
                this.recipients.push(recipient);
                this.listOfRecipients.emit({ recipients: this.recipients, valid: this.checkValidity() });
            }
            // Clear the input value
            event.chipInput.clear();
        }
    }
    remove(recipient) {
        this.inputTouched = true;
        const index = this.recipients.indexOf(recipient);
        if (index >= 0) {
            this.recipients.splice(index, 1);
            this.listOfRecipients.emit({ recipients: this.recipients, valid: this.checkValidity() });
        }
    }
    checkValidity() {
        return this.recipients.length > 0 ? true : false;
    }
    static propDecorators = {
        recipients: [{ type: Input }],
        errorMessage: [{ type: Input }],
        listOfRecipients: [{ type: Output }]
    };
};
RecipientsChipsComponent = __decorate([
    Component({
        selector: "app-recipients-chips",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientsChipsComponent);
export { RecipientsChipsComponent };
